import React from 'react'
import { useRecoilValue } from 'recoil'

import AlertModal from '@/shared/components/common/Modal/AlertModal'
import ConfirmModal from '@/shared/components/common/Modal/ConfirmModal'
import MVNOModal from '@/shared/components/common/Modal/MVNOModal'
import NoticeModal from '@/shared/components/common/Modal/NoticeModal'
import RefundModal from '@/shared/components/common/Modal/RefundModal'
import SecurityModal from '@/shared/components/common/Modal/SecurityModal'
import TermsModal from '@/shared/components/common/Modal/TermsModal'
import TimeOfBirth from '@/shared/components/common/Modal/TimeOfBirth'
import VulnerableModal from '@/shared/components/common/Modal/VulnerableModal'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import useModalText from '@/shared/hooks/useModalText'
import { TelTypeState } from '@/shared/store'
import { ModalBox, ModalWrap } from '@/styles/common/modal'

const Modal = (props: any) => {
  const {
    isOpen,
    toggle,
    doubleToggle,
    type,
    ClickFunc,
    ClickFunc2,
    ClickFunc3,
    ClickFunc4,
    ClickFunc5,
    handleDevideSktCancel,
    handleDevideSktConfirm,
    handleAlertReloadConfirm,
    option,
    setOption,
  } = props
  const modalOption = useModalText()
  const { width } = useWindowDimensions()
  const TelType = useRecoilValue(TelTypeState)
  const TextItem = modalOption?.ModalTextOptions?.find((element: any) => element.idx === setOption)

  const caseByClickFunc = () => {
    switch (true) {
      case option ===
        '서비스 해지가 완료되었습니다.\n가입 당일 해지 고객은 요금이 부과되지 않습니다.':
      case option?.title === '서비스 해지 및 환불 접수 완료':
      case option?.title === '환불 접수 완료':
        toggle()
        window.location.reload()
        break
      case setOption === 1066:
      case setOption === 1067:
      case option === '요청 정보가 없습니다.':
      case option === '인증번호 3회 오류로 만료되었습니다. 다시 진행해 주세요.':
        toggle()
        window.location.reload()
        break
      default:
        return ClickFunc()
    }
  }
  const InnerComponent = (type: any) => {
    switch (type) {
      case 'alert':
        return (
          <AlertModal
            option={
              setOption === 0 || setOption === 1066 || setOption === 1067 ? option : TextItem?.title
            }
            ClickFunc={
              setOption === 1066 || setOption === 1067 ? handleAlertReloadConfirm : caseByClickFunc
            }
          />
        )
      case 'terms':
        return <TermsModal option={option} ClickFunc={ClickFunc} />
      case 'MVNO':
        return (
          <MVNOModal
            option={option}
            ClickFunc={toggle}
            ClickFunc1={ClickFunc}
            ClickFunc2={ClickFunc2}
          />
        )
      case 'security':
        return (
          <SecurityModal
            isOpen={isOpen}
            ClickFunc={toggle}
            ClickFunc2={doubleToggle}
            ClickFunc3={ClickFunc3}
            ClickFunc4={ClickFunc4}
            ClickFunc5={ClickFunc5}
          />
        )
      case 'timeOfBirth':
        return <TimeOfBirth ClickFunc={ClickFunc} />
      case 'notice':
        return <NoticeModal isOpen={isOpen} ClickFunc={toggle} />
      case 'refund':
        return <RefundModal option={option} ClickFunc={caseByClickFunc} />
      case 'Vulnerable':
        return <VulnerableModal onCancel={toggle} onConfirm={ClickFunc} telecom={TelType} />
      case 'confirm':
        return (
          <ConfirmModal
            message={option}
            onCancel={setOption === 1065 ? handleDevideSktCancel : toggle}
            onConfirm={setOption === 1065 ? handleDevideSktConfirm : ClickFunc}
          />
        )
    }
  }

  return (
    <ModalWrap toggle={isOpen} zIndex={9990} width={`${width}px`}>
      <ModalBox onClick={(e: any) => e.stopPropagation()}>{InnerComponent(type)}</ModalBox>
    </ModalWrap>
  )
}
export default Modal
